import React, {
  useState,
  useEffect,
  forwardRef,
  Fragment,
  useImperativeHandle,
  useRef,
} from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Badge, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { connect, useDispatch } from "react-redux";
import { Row, Col, Card, Tab, Nav, Button } from "react-bootstrap";
import { withRouter } from "../../../App";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import Select from "react-select";
import {
  getCompanyJob,
  getRequirementById,
  updateRequirement,
  hireCandidate,
} from "../../../store/actions/Jobs/jobActions";
import { industrySector } from "../../constant/industrySector";
// import Candidates from "./Candidates";
import { days } from "../../constant/weekday";
import { get } from "../../../services/api";
import { debounce } from "../../../utils/debounce";

const UpdateRequirementPlan = ({ token, selectedRequirement, companies, jobTypeList, payRateTypes }) => {
  const [searchParams] = useSearchParams();
  const weekStart = searchParams.get("weekStart");
  const weekEnd = searchParams.get("weekEnd");
  const [jobTypeListValues, setJobTypeListValues] = useState([]);

  const updateRequirementId = searchParams.get("id");
  const formMode = searchParams.get("mode");
  const isView = formMode === "view";

  
    const [invoiceTo, setInvoiceTo] = useState([]);
    const [reportTo, setReportTo] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [payRateType, setPayRateType] = useState([]);
    
  const [postCodeResults, setPostCodeResults] = useState([]);
  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(
      `https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    const { locality: locality = "", postcode: postCode = "" } = result;

    setFormData((prevFormData) => ({
      ...prevFormData,
      location: locality,
      postCode,
    }));
    setPostCodeResults([]);
  };
  const nav = useNavigate();
  // useEffect(() => {
  //   dispatch(getCandidatesJob(token));
  // }, []);

  useEffect(() => {
    if (updateRequirementId) {
      dispatch(getRequirementById(updateRequirementId, token));
    }
    if(jobTypeList) {
      setJobTypeListValues(jobTypeList?.map((itm)=>itm.value));
    }
    if(payRateTypes) {
      setPayRateType(payRateTypes?.map((itm)=>itm.value));
    }
  }, [updateRequirementId, jobTypeList, payRateTypes]);

  const tabData = [
    {
      name: "Master",
      icon: "home",
    },
    {
      name: "Classification",
      icon: "info",
    },
  ];
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    companyId: "",
    company: "",
    jobTitle: "",
    jobID: "",
    latestActionDate: new Date(),
    jobStartDate: null,
    jobEndDate: null,
    service: "BOOKING",
    salary: 0,
    status: "LIVE",
    payIn: "",
    feePercentage: "",
    reason: "Standard Requirement",
    accountNumber: "",
    orderNumber: "",
    controller: "",
    currency: "sterling",
    postCode: "",
    payRates: [],
    daysOfWork: [],
    location: "",
    jobType: "Industrial",
    jobContact: "",
    jobReportTo: "",
    jobInvoiceTo: "",
    statusDate: new Date(),
    quantity: 1,
    industrySector: "",
    jobTitles: "",
    skills: "",
    qualifications: "",
    marketing: "",
    hoursOfWork: "",
    duties: "",
    healthSafety: "",
    experience: "",
    notes: "",
  });

  useEffect(() => {
    setFormData({
      ...selectedRequirement,
      latestActionDate: selectedRequirement?.latestActionDate
        ? new Date(selectedRequirement?.latestActionDate)
        : null,
      jobEndDate: selectedRequirement?.jobEndDate
        ? new Date(selectedRequirement?.jobEndDate)
        : null,
      jobStartDate: selectedRequirement?.jobStartDate
        ? new Date(selectedRequirement?.jobStartDate)
        : null,
      updatedAt: new Date(),
      hoursOfWork: selectedRequirement?.hoursOfWork || "",
      duties: selectedRequirement?.duties || "",
      healthSafety: selectedRequirement?.healthSafety || "",
      experience: selectedRequirement?.experience || "",
      notes: selectedRequirement?.notes || "",
    });
    if (selectedRequirement?.companyId) {
      getCompanyPeople(selectedRequirement?.companyId);
    }
    setPayRates(selectedRequirement?.payRates || []);
  }, [selectedRequirement]);

  const getCompanyPeople = async (id) => {
    const res = await get("/api/company-contacts/company/" + id, token);
    
    if (res && res.length > 0) {
      const filteredInvoiceTo = res.filter(contactPerson => contactPerson.position === 'Invoice To').map((item)=>({value: item?._id, label: (item.firstName + " " + item.lastName)}));
      const filteredReportTo= res.filter(contactPerson => contactPerson.position === 'Report To').map((item)=>({value: item?._id, label: (item.firstName + " " + item.lastName)}));
      const filteredContact = res.filter(contactPerson => contactPerson.position === 'Contact').map((item)=>({value: item?._id, label: (item.firstName + " " + item.lastName)}));


      setInvoiceTo(filteredInvoiceTo);
      setReportTo(filteredReportTo);
      setContactList(filteredContact);
    }
    
  };

  const [errors, setErrors] = useState({});
  const [payRates, setPayRates] = useState([]);

  const [activeTab, setActiveTab] = useState(tabData[0].name.toLowerCase()); // Set initial active tab
  const resetForm = () => {
    setFormData({
      ...formData,
      payRates: [],
      daysOfWork: [],
    });
    setPayRates([]);
    setErrors({});
  };

  const handleSelect = (key) => {
    setActiveTab(key);
  };
  const validate = () => {
    const newErrors = {};
    if (activeTab === "master") {

    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all required fields.");
    }

    return Object.keys(newErrors).length === 0;
  };
  // Handle input changes
  const [query, setQuery] = useState("");
  const fetchData = async (searchTerm) => {
    const apiData = await fetch(
      `https://api.getaddress.io/autocomplete/${searchTerm}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    setPostCodeResults(result.suggestions);
  };
  const handlePostCodeQueryChange = (inputQuery) => {
    setQuery(inputQuery);
    debounce(fetchData(inputQuery));
  };
  const handleInputChange = (field, value) => {
    if (field === "postCode") {
      handlePostCodeQueryChange(value);
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleDaySelection = (day) => {
    setFormData((prev) => {
      const daysOfWork = prev?.daysOfWork?.includes(day)
        ? prev.daysOfWork.filter((d) => d !== day)
        : [...prev.daysOfWork, day];
      return { ...prev, daysOfWork };
    });
  };

  const handleAddRow = () => {
    setPayRates((prev) => [
      ...prev,
      { payRate: "", chargeRate: "", type: "", band: "", description: "" },
    ]);
  };

  const handleRemoveRow = (index) => {
    setPayRates((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRateChange = (index, field, value) => {
    setPayRates((prev) => {
      const updatedRates = [...prev];
      updatedRates[index][field] = value;
      return updatedRates;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const emptyPayRates = payRates.filter(rate => rate.payRate === "" || rate.payRate === null);
    const emptyChargeRates = payRates.filter(rate => rate.chargeRate === "" || rate.chargeRate === null);
    
    if (emptyPayRates.length > 0) {
      toast.error("Pay Rate cannot be empty. Please enter values for all pay rates.");
      return;
    }
    
    if (emptyChargeRates.length > 0) {
      toast.error("Charge Rate cannot be empty. Please enter values for all charge rates.");
      return;
    }
    
    if (validate()) {
      const { __v, _id, ...payload } = formData;
      const data = { ...payload, payRates };
      if (selectedRequirement?._id) {
        dispatch(updateRequirement(data, selectedRequirement?._id, token));
      } else {
        //dispatch(addCandidates(payload, () => { }, token));
      }
    }
  };
  /**
   * people actions
   */
  return (
    <>
      <Fragment>
        <div className="container-fluid">
          <div className="col-xl-12 col-lg-12">
            <div className="card profile-card card-bx m-b30 p-4">
              <Tab.Container activeKey={activeTab} onSelect={handleSelect}>
                <Nav as="ul" className="nav-tabs">
                  {tabData.map((data, i) => (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link eventKey={data.name.toLowerCase()}>
                        <i className={`la la-${data.icon} me-2`} />
                        {data.name}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
                <Tab.Content className="pt-4">
                  <Tab.Pane eventKey="master" key={1}>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        {/* Company Name */}
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Job ID <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={formData.jobID}
                            onChange={(e) =>
                              handleInputChange("jobID", e.target.value)
                            }
                          />
                          {errors.jobID && (
                            <small className="text-danger">
                              {errors.jobID}
                            </small>
                          )}
                        </div>
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Job Title <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            disabled={isView}
                            className="form-control"
                            value={formData.jobTitle}
                            onChange={(e) =>
                              handleInputChange("jobTitle", e.target.value)
                            }
                          />
                          {errors.jobTitle && (
                            <small className="text-danger">
                              {errors.jobTitle}
                            </small>
                          )}
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Job Type <span className="text-danger">*</span>
                          </label>
                          <Select
                            isDisabled={isView}
                            value={
                              formData.jobType
                                ? {
                                    value: formData.jobType,
                                    label: formData.jobType,
                                  }
                                : null
                            }
                            options={jobTypeListValues.map((itm) => ({
                              value: itm,
                              label: itm,
                            }))}
                            onChange={(selectedOption) =>
                              handleInputChange(
                                "jobType",
                                selectedOption ? selectedOption.value : ""
                              )
                            }
                          />
                          {errors.jobType && (
                            <small className="text-danger">
                              {errors.jobType}
                            </small>
                          )}
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Location
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.location}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("location", e.target.value)
                            }
                          />
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Postcode</label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.postCode}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("postCode", e.target.value)
                            }
                          />
                          {postCodeResults?.length > 0 && (
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                maxHeight: "150px", // Medium size scrollable div
                                overflowY: "auto",
                                marginTop: "5px",
                                padding: "10px",
                                backgroundColor: "#fff",
                              }}
                            >
                              {postCodeResults?.map((suggestion, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "5px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid #eee",
                                  }}
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  } // Handle click on suggestion
                                >
                                  {suggestion.address}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                       <div className="col-xl-6 mb-3">
  <label className="form-label">Qty</label>
  <input
    type="number"
    className="form-control"
    min={0}
    disabled={isView}
    value={formData.quantity}
    onChange={(e) => handleInputChange("quantity", e.target.value)}
    onWheel={(e) => e.target.blur()}
  />
</div>
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Company <span className="text-danger">*</span>
                          </label>
                          <Select
                            isDisabled={isView}
                            value={
                              formData.companyId
                                ? {
                                    value: formData.companyId,
                                    label: formData.company,
                                  }
                                : null
                            }
                            options={companies?.map((itm) => ({
                              value: itm?._id,
                              label: itm?.companyName,
                            }))}
                            onChange={(selectedOption) => {
                              const companyName =
                                companies?.find(
                                  (itm) => itm._id === selectedOption?.value
                                )?.companyName || "";
                              getCompanyPeople(selectedOption?.value);
                              setFormData((prev) => ({
                                ...prev,
                                companyId: selectedOption?.value || "",
                                company: companyName,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                companyId: "",
                                company: "",
                              }));
                            }}
                          />
                        </div>

                        {/* <div className="col-xl-6 mb-3">
                          <label className="form-label">Contact</label>
                          <Select
                            isDisabled={isView}
                            options={contactList}
                            value={
                              formData.jobContact
                                ? contactList.find(
                                    (option) =>
                                      option.value === formData.jobContact
                                  )
                                : null
                            }
                            onChange={(selectedOption) => {
                              setFormData((prev) => ({
                                ...prev,
                                jobContact: selectedOption
                                  ? selectedOption.value
                                  : "",
                              }));
                            }}
                            placeholder="Job Contact"
                          />
                        </div> */}

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Report To</label>
                          <Select
                            isDisabled={isView}
                            options={reportTo}
                            value={
                              formData.jobReportTo
                                ? reportTo.find(
                                    (option) =>
                                      option.value === formData.jobReportTo
                                  )
                                : null
                            }
                            onChange={(selectedOption) => {
                              setFormData((prev) => ({
                                ...prev,
                                jobReportTo: selectedOption
                                  ? selectedOption.value
                                  : "",
                              }));
                            }}
                            placeholder="Report To"
                          />
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Invoice To</label>
                          <Select
                            isDisabled={isView}
                            options={invoiceTo}
                            value={
                              formData.jobInvoiceTo
                                ? invoiceTo.find(
                                    (option) =>
                                      option.value === formData.jobInvoiceTo
                                  )
                                : null
                            }
                            onChange={(selectedOption) => {
                              setFormData((prev) => ({
                                ...prev,
                                jobInvoiceTo: selectedOption
                                  ? selectedOption.value
                                  : "",
                              }));
                            }}
                            placeholder="Invoice To"
                          />
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Service <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control form-select"
                            value={formData.service}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("service", e.target.value)
                            }
                          >
                            <option value=""></option>
                            <option value="BOOKING">BOOKING</option>
                          </select>
                          {errors.service && (
                            <small className="text-danger">
                              {errors.service}
                            </small>
                          )}
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Controller <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData.controller}
                            disabled
                          />
                        </div>
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Fee %</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={isView}
                            value={formData.feePercentage}
                            onChange={(e) =>
                              handleInputChange("feePercentage", e.target.value)
                            }
                          />
                        </div>
                        {[
                          { label: "Job Start Date", field: "jobStartDate" },
                          { label: "Job End Date", field: "jobEndDate" },
                        ].map(({ label, field }) => (
                          <div className="col-xl-6 mb-3" key={field}>
                            <label className="form-label">
                              {label} <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                              placeholder="dd/MM/yyyy"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              selected={formData[field]}
                              onChange={(date) =>
                                handleInputChange(field, date)
                              }
                            />
                            {errors[field] && (
                              <small className="text-danger">
                                {errors[field]}
                              </small>
                            )}
                          </div>
                        ))}

                        {/* Status */}
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Status <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            disabled={isView}
                            value={formData.status}
                            onChange={(e) =>
                              handleInputChange("status", e.target.value)
                            }
                          >
                            <option value=""></option>
                            <option value="LIVE">LIVE</option>
                            <option value="ARCHIVED">ARCHIVED</option>
                            <option value="CLOSED">CLOSED</option>
                          </select>
                          {errors.status && (
                            <small className="text-danger">
                              {errors.status}
                            </small>
                          )}
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Account Number</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={isView}
                            value={formData.accountNumber}
                            onChange={(e) =>
                              handleInputChange("accountNumber", e.target.value)
                            }
                          />
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">PO Number</label>
                          <input
                            type="text"
                            disabled={isView}
                            className="form-control"
                            value={formData.orderNumber}
                            onChange={(e) =>
                              handleInputChange("orderNumber", e.target.value)
                            }
                          />
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Reason</label>
                          <select
                            className="form-control"
                            value={formData.reason}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("reason", e.target.value)
                            }
                          >
                            <option value=""></option>
                            <option value="Standard Requirement">
                              Standard Requirement
                            </option>
                          </select>
                        </div>
                        <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Hours of Work
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.hoursOfWork}
                          onChange={(e) =>
                            handleInputChange("hoursOfWork", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Duties
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            handleInputChange("duties", e.target.value)
                          }
                          value={formData.duties}
                        />
                      </div>
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Experience
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            handleInputChange("experience", e.target.value)
                          }
                          value={formData.experience}
                        />
                      </div>
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Notes
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            handleInputChange("notes", e.target.value)
                          }
                          value={formData.notes}
                        />
                      </div>
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Health and Safety
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            handleInputChange("healthSafety", e.target.value)
                          }
                          value={formData.healthSafety}
                        />
                      </div>
                        <div className="col-12 mb-3">
                          <label className="form-label">Days of Work</label>
                          <div className="d-flex flex-wrap">
                            {days.map((day) => (
                              <div key={day} className="form-check me-3">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={day}
                                  disabled={isView}
                                  checked={formData.daysOfWork?.includes(day)}
                                  onChange={() => handleDaySelection(day)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={day}
                                >
                                  {day}
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <label className="form-label">Pay Rates</label>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Pay Rate (&#xa3; in hours)</th>
                                <th>Charge Rate (&#xa3; in hours)</th>
                                <th>Type</th>
                                <th>Band</th>
                                <th>Description</th>
                                <th>Charge %</th>
                                {!isView && <th>Actions</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {payRates.map((row, index) => (
                                <tr key={index}>
                                  {[
                                    "payRate",
                                    "chargeRate",
                                    "type",
                                    "band",
                                    "description",
                                  ].map((field) => (
                                    <td key={field}>
                                      {field === "type" ? (
                                        <select
                                          style={{ width: "90px" }}
                                          className="form-control"
                                          value={row[field]}
                                          onChange={(e) =>
                                            handleRateChange(
                                              index,
                                              field,
                                              e.target.value
                                            )
                                          }
                                        >
                                          {payRateType?.map((itm) => (
                                            <option value={itm}>{itm}</option>
                                          ))}
                                        </select>
                                      ) : (
                                        <input
                                          type={
                                            field === "payRate" ||
                                            field === "chargeRate"
                                              ? "number"
                                              : "text"
                                          }
                                          className="form-control"
                                          value={row[field]}
                                          onChange={(e) =>
                                            handleRateChange(
                                              index,
                                              field,
                                              e.target.value
                                            )
                                          }
                                        />
                                      )}
                                    </td>
                                  ))}
                                  <td>
                                    {row.payRate && row.chargeRate
                                      ? (
                                          ((row.chargeRate - row.payRate) /
                                            row.chargeRate) *
                                          100
                                        ).toFixed(2) // Correct percentage increase calculation
                                      : "--"}
                                  </td>
                                  {!isView && (
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => handleRemoveRow(index)}
                                      >
                                        Remove
                                      </button>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {!isView && (
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={handleAddRow}
                              >
                                Add Row
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="card-footer">
                        {isView ? (
                          <>&nbsp;</>
                        ) : (
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>
                        )}

                        <button
                          onClick={() => {
                              if (weekStart && weekEnd) {
                                nav(`/requirement-plans?weekStart=${weekStart}&weekEnd=${weekEnd}`);
                              } else {
                                nav("/requirement-plans");
                              }
                            }}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </Tab.Pane>

                  <Tab.Pane eventKey="classification" key={2}>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Industry Sector{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control form-select"
                            value={formData.industrySector}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange(
                                "industrySector",
                                e.target.value
                              )
                            }
                          >
                            <option value=""></option>
                            {industrySector?.map((itm) => (
                              <option value={itm}>{itm}</option>
                            ))}
                          </select>
                          {errors.industrySector && (
                            <small className="text-danger">
                              {errors.industrySector}
                            </small>
                          )}
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Job Titles</label>
                          <select
                            className="form-control form-select"
                            value={formData.jobTitles}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("jobTitles", e.target.value)
                            }
                          >
                            <option value=""></option>
                          </select>
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Skills</label>
                          <select
                            className="form-control form-select"
                            value={formData.skills}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("skills", e.target.value)
                            }
                          >
                            <option value=""></option>
                          </select>
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Qualification</label>
                          <select
                            className="form-control form-select"
                            value={formData.qualifications}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange(
                                "qualifications",
                                e.target.value
                              )
                            }
                          >
                            <option value=""></option>
                            <option value="Graduate">Graduate</option>
                          </select>
                        </div>

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Marketing</label>
                          <select
                            className="form-control form-select"
                            value={formData.marketing}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("marketing", e.target.value)
                            }
                          >
                            <option value=""></option>
                            <option value="Opt-in">Opt-in</option>
                            <option value="Opt-out">Opt-out</option>
                          </select>
                        </div>
                      </div>
                      <div className="card-footer">
                        {isView ? (
                          <>&nbsp;</>
                        ) : (
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>
                        )}

                        <button
                          onClick={() => {
                              if (weekStart && weekEnd) {
                                nav(`/requirement-plans?weekStart=${weekStart}&weekEnd=${weekEnd}`);
                              } else {
                                nav("/requirement-plans");
                              }
                            }}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </Fragment>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    companies: state.companies.companies,
    selectedRequirement: state.jobs.selectedRequirement,
    jobTypeList: state?.dropDownValues?.dropDownValues?.jobType || [],
    payRateTypes: state?.dropDownValues?.dropDownValues?.payRateTypes || [],
  };
};

export default withRouter(connect(mapStateToProps)(UpdateRequirementPlan));
